export const versionNum = process.env.REACT_APP_VERSION;
